import React, { useContext, useState } from "react";
import { TranslationContext } from "../../../contexts/TranslationContext";
import { ILanguage, SetTranslationsRequest, Translation, TranslationAdminClient } from "../../../services/WebApiClient";
import { useClient } from "../../../util/useClient";
import { SortBy } from "../../Table/SortBy";
import { IColumn, Table } from "../../Table/Table";
import "./SingleLanguageEditor.scss";

interface ITranslation {
    key: string;
    value: string;
    defaultValue: string;
    isChanged: boolean;
}

export function SingleLanguageEditor(props: {
    language: ILanguage,
    onChange: () => void,
}) {
    const {
        language,
        onChange,
    } = { ...props };

    const tc = useContext(TranslationContext);
    const client = useClient(TranslationAdminClient);

    const [translations, setTranslations] = useState<ITranslation []>(() =>
        language.translations.map(t => ({
            key: t.key,
            value: t.value ?? "",
            defaultValue: t.defaultValue,
            isChanged: false,
        }))
    );

    function setTranslation(v: string, index: number) {
        const newTranslation = {
            ...translations[index],
            isChanged: true,
            value: v
        };
        const newTranslations = [...translations];
        newTranslations[index] = newTranslation;
        setTranslations(newTranslations);
    }

    function saveTranslations(evt: React.FormEvent) {
        evt.preventDefault();
        try {
            client.setTranslations(new SetTranslationsRequest({
                translations: translations
                    .filter(t => t.isChanged)
                    .map(t => new Translation({
                        defaultValue: "",
                        key: t.key,
                        value: (t.value === "") ? null : t.value,
                        languageId: language.id
                    }))
            }))
        }
        finally {
            onChange();
        }
    }

    const tableCols: IColumn<ITranslation >[] = [
        {
            key: "key",
            content: t => t.key,
            header: tc.translator("admin language table header key", "Nøgle"),
            sort: SortBy.String(t => t.key),
            className: "key"
        },
        {
            key: "defaultValue",
            content: t => t.defaultValue,
            header: tc.translator("admin language table header defaultValue", "Standard"),
            sort: SortBy.String(t => t.defaultValue),
            className:"default-value"
        },
        {
            key: "value",
            //content: (t, index) => (
            //    <input type="text"
            //        className="form-control"
            //        key={index}
            //        value={t.value}
            //        onChange={evt => setTranslation(evt.target.value, index)} />
            //),
            content: (t, index) => (
                <textarea className="form-control"
                    key={index}
                    value={t.value}
                    onChange={evt => setTranslation(evt.target.value, index)}
                ></textarea>
                ),
            header: tc.translator("admin language table header value", "Oversættelse"),
            sort: SortBy.String(t => t.value),
            className:"value"
        }
    ];

    return (
        <div className="single-language-editor">
            <h4>{language.name}</h4>
            <form onSubmit={saveTranslations}>
                <Table 
                    columns={tableCols}
                    rows={translations}
                    tableProps={{ className: 'table table-striped table-hover language-editor-table' }}
                />

                <button className="btn btn-primary"
                    type="submit">
                    {tc.translator("admin language button submit", "Gem")}
                </button>
            </form>
        </div>
    );
}
